/* eslint-disable */


import { blueGrey, cyan, green, grey, orange, yellow } from '@material-ui/core/colors';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import Colors from '../../Support/Theme/Colors/Colors';

export const orderStatusColors = {
  [ORDER_STATUS_CANCELLED]: {
    color: grey,
    index: 900,
  },
  [ORDER_STATUS_COMPLETED]: {
    color: green,
    index: 600,
  },
  [ORDER_STATUS_CONFIRMED]: {
    color: cyan,
    index: 300,
  },
  [ORDER_STATUS_DELIVERING]: {
    color: yellow,
    index: 600,
  },
  [ORDER_STATUS_ON_HOLD]: {
    color: blueGrey,
    index: 400,
  },
  [ORDER_STATUS_TO_BE_CONFIRMED]: {
    color: orange,
    index: 600,
  },
};

export const orderStatusChipColors = {
  [ORDER_STATUS_CANCELLED]: {
    color: grey,
    textColor: `#fff`,
    index: 900,
  },
  [ORDER_STATUS_COMPLETED]: {
    color: Colors.boralgreen,
    textColor: `#fff`,
    index: 500,
  },
  [ORDER_STATUS_CONFIRMED]: {
    color: Colors.montecarlo,
    index: 900,
  },
  [ORDER_STATUS_DELIVERING]: {
    color: Colors.boralyellow,
    index: 900,
  },
  [ORDER_STATUS_ON_HOLD]: {
    color: Colors.raven,
    textColor: `#fff`,
    index: 600,
  },
  [ORDER_STATUS_TO_BE_CONFIRMED]: {
    color: Colors.california,
    index: 900,
  },
};

/**
 * Create background color styles
 * @param {Styles} styles The result of `createStyles`
 * @param {any} color The color palette array from Material UI and the color index
 * @returns The background styles
 */
const backgroundStyle = ({ theme }, { color, index }) => ({
  backgroundColor: color[index],
  color: theme ? theme.palette.getContrastText(color[index]) : '#fff',
});

/**
 * Create background styles used by OrderStatus
 * @param {Styles} styles The result of `createStyles`
 * @returns The OrderStatus styles
 */
const backgroundStyles = ({ theme }) => {
  const unit = theme ? theme.spacing(1) : 8;
  return {
  [ORDER_STATUS_CANCELLED]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_CANCELLED]),
  [ORDER_STATUS_COMPLETED]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_COMPLETED]),
  [ORDER_STATUS_CONFIRMED]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_CONFIRMED]),
  [ORDER_STATUS_DELIVERING]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_DELIVERING]),
  [ORDER_STATUS_ON_HOLD]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_ON_HOLD]),
  [ORDER_STATUS_TO_BE_CONFIRMED]: backgroundStyle({ theme }, orderStatusColors[ORDER_STATUS_TO_BE_CONFIRMED]),
  orderStatusTag: {
    alignItems: `center`,
    borderRadius: theme ? theme.shape.borderRadius : 4,
    display: `flex`,
    height: `${unit * 3}px`,
    padding: `${unit / 2}px ${unit}px`,
  },
}};

/**
 * Create Chip styles
 * @param {Styles} styles The result of `createStyles`
 * @param {any} color The color palette array from Material UI and the color index
 * @returns The chip styles
 */
const chipStyle = ({ theme }, { textColor, color, index }) => {
  const primary = theme ? theme.palette.text.primary : '#000';
  return {
  '&:hover, &:focus': {
    backgroundColor: color[index - 100],
    color: `#fff`,
  },
  backgroundColor: color[index],
  color: textColor || primary,
}};

/**
 * Create Chip styles used by OrderStatusGroup
 * @param {Styles} styles The result of `createStyles`
 * @returns The Order styles for checkboxes
 */
const chipStyles = ({ theme }) => {

  const unit = theme ? theme.spacing(1) : 8;
  return {
  root: {
    cursor: `pointer`,
  },
  clickable: {
    marginBottom: unit,
  },
  [ORDER_STATUS_CANCELLED]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_CANCELLED]),
  [ORDER_STATUS_COMPLETED]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_COMPLETED]),
  [ORDER_STATUS_CONFIRMED]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_CONFIRMED]),
  [ORDER_STATUS_DELIVERING]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_DELIVERING]),
  [ORDER_STATUS_ON_HOLD]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_ON_HOLD]),
  [ORDER_STATUS_TO_BE_CONFIRMED]: chipStyle({ theme }, orderStatusChipColors[ORDER_STATUS_TO_BE_CONFIRMED]),
}};

const orderServiceStyles = {
  /**
   * The background styles
   */
  backgroundStyles,

  /**
   * The chip styles
   */
  chipStyles,
};

export default orderServiceStyles;
